let sdkPromise = null;

export function loadLogixSDK() {
    if (sdkPromise) return sdkPromise;

    sdkPromise = new Promise((resolve, reject) => {
        const jsReady =
            window.LogixPlayerComponent && window.playerBuilder;

        if (jsReady) {
            resolve();
            return;
        }

        // Load CSS first
        if (!document.getElementById("logix-player-css")) {
            const link = document.createElement("link");
            link.id = "logix-player-css";
            link.rel = "stylesheet";
            link.href = "/player/logixplayerCoreSDK.css";
            document.head.appendChild(link);
        }

        // Load JS SDK
        if (!document.getElementById("logix-player-js")) {
        const script = document.createElement("script");
        script.src = "/player/logixplayerCoreSDK.js";
        script.async = true;

        script.onload = () => resolve();
        script.onerror = reject;

        document.body.appendChild(script);
        }
    });

    return sdkPromise;
}